<template>
  <v-select
    :label="label"
    :items="getSelectItems"
    :hide-details="shouldHideDetails"
    :value="data"
    @change="$emit('change', $event)"
  ></v-select>
</template>

<script>
  import { mapGetters } from 'vuex'

	export default {
		name: 'InspectionInstrumentInput',

		props: {
      data: {
        type: [String, Number],
        required: true
      },

      hideDetails: {
        type: Boolean,
        required: false,
        default: false
      }
    },

		data () {
			return {
        field: 'inspection_instrumentID',
        label: 'Scope ID'
			}
		},

    computed: {
      ...mapGetters('examinations', [
        'getInspectionInstrumentList'
      ]),

      getSelectItems () {
        return this.getInspectionInstrumentList.map(item => {
          return {
            text: item.inspection_instrument,
            value: item.id
          }
        })
      },

      shouldHideDetails () {
        return this.hideDetails
      }
    }
	}
</script>